// extracted by mini-css-extract-plugin
module.exports = {"header":"RenameCollectionModal_header__vBNuv"};